import 'slick-carousel/slick/slick.js';
//import './vendors/contactform7.js'; 
import 'jquery-lazy'; 
import 'jquery-inview';
import 'jquery-match-height'; 
import 'sticky-kit/dist/sticky-kit.js'; 

/* ========================================================================

 * DOM-based Routing

 * Based on http://goo.gl/EUTi53 by Paul Irish

 *

 * Only fires on body classes that match. If a body class contains a dash,

 * replace the dash with an underscore when adding it to the object below.

 *

 * .noConflict()

 * The routing is enclosed within an anonymous function so that you can

 * always reference jQuery with $, even when in .noConflict() mode.

 * ======================================================================== */
function show_map(lat, lng, trigger) {
    var localtion = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
    };
    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 15,
        center: localtion
    });
    var marker = new google.maps.Marker({
        position: localtion,
        map: map
    });
    // $('.group-map').removeClass('close');
    $("#office-address").html($(trigger).find('.office-address').html());
    $("#office-directions").html($(trigger).find('.office-directions').html());
    $(".gmap-link").attr("href", "http://www.google.se/maps/place/" + lat + ',' + lng);
    $('.map-match').matchHeight();
    $('.group-map').slideToggle('show');
    $('.list-style-1').removeClass('show');
    $('.list-style-1').slideToggle('close');
}
(function($) {

		function getCookie(cname) {
		    var name = cname + "=";
		    var decodedCookie = decodeURIComponent(document.cookie);
		    var ca = decodedCookie.split(';');
		    for(var i = 0; i <ca.length; i++) {
		        var c = ca[i];
		        while (c.charAt(0) == ' ') {
		            c = c.substring(1);
		        }
		        if (c.indexOf(name) == 0) {
		            return c.substring(name.length, c.length);
		        }
		    }
		    return "";
		} 

		function setCookie(cname, cvalue, exdays) {
		    var d = new Date();
		    d.setTime(d.getTime() + (exdays*24*60*60*1000));
		    var expires = "expires="+ d.toUTCString();
		    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		}

		function getCaptchaToken() {
			grecaptcha.ready(function () {
          grecaptcha.execute(captcha_key, { action: 'contact' }).then(function (token) {
              $("input[name='_recaptcha_response']").val(token);
          });
      });
		}

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {

            			$(".lazy").Lazy();

            			$("#service-areas .box-list-item").click(function() {
            				document.location = $(this).find('.link-more').attr("href");
            			});

									$(".office-filter").click(function() {
										$(".office-filter").removeClass("active");
										$(this).addClass("active");
										filterStaff();
									});

									$("#staff-search").keyup(function() {
										filterStaff();
									});

									function filterStaff() {
										var search_str = $("#staff-search").val().toLowerCase();
										$(".person").hide();
										$(".person").each(function() {
											var name = $(this).find('.name').text().toLowerCase();

											if($(".office-filter.active").data("office") == "") {
												if(search_str == "" || name.indexOf(search_str) !== -1) {
													$(this).show();
												} 
											} else {
												if($(this).hasClass($(".office-filter.active").data("office"))) {
													if(search_str == "" || name.indexOf(search_str) !== -1) {
														$(this).show();
													} 
												}
											}

											if(search_str != "" && name.indexOf(search_str) !== -1) {
												if($(".office-filter.active").length == 0 || $(this).hasClass($(".office-filter.active").data("office"))) {
													$(this).show();
												}
											} 

										});
									}

				        if(getCookie("accepted_cookies") != "true") {
					        $("#cookiebar").slideToggle();
					        $("#cookie-agree, #cookiebar img").click(function() {
					        	setCookie("accepted_cookies", "true", 365);
					        	$("#cookiebar").slideUp();
					        });
				        }
            		
            		if($(window).width() > 768) {
            			$('.small-detail').matchHeight();
            		}

                $('.matchMenu').matchHeight();
                $('.sj-content').matchHeight();
                $('.oms-content').matchHeight();
                $('.box-list-item').matchHeight();
                $('.box-list-item-2').matchHeight();
                $('.box-list-item-3').matchHeight();
                $('.map-match').matchHeight();
                $('.mobile-menu').click(function() {
                    // $('.menu-detail').slideToggle("open");
                    $('.group-span span').toggleClass("close");
                    $('.menu-detail').slideToggle('open');
                    $('header').toggleClass('active');
                    $('.image-logo').toggleClass('active');
                });
                if ($(window).width() > 767) {
                    $('p').removeClass('more-mobile-green');
                    $('p').removeClass('more-mobile-white');
                }
                // JavaScript to be fired on all pages
                $('.link-more-read.white').click(function() {
                    $(this).parent().find("div.more-mobile-green").toggleClass("active");
                    $(this).toggleClass("active");
                    $(this).parents('.fade-text-in-mobile').toggleClass("fade");
                });
                $('.link-more-read.black').click(function() {
                    $(this).parent().find("div.more-mobile-white").toggleClass("active");
                    $(this).toggleClass("active");
                    $(this).parents('.fade-text-in-mobile').toggleClass("fade");
                });
                $('li.bg-gray input').focusin(function() {
                    $('li.bg-gray').addClass("active");
                });
                $('li.bg-gray input').focusout(function() {
                    $('li.bg-gray').removeClass("active");
                });
                $(".limit-load-more").click(function() {
                    $(".limit-items").removeClass("limit-items");
                    $(this).remove();
                    return false;
                });
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired

                var captchaLoaded = false;
								$(".wpforms-form").one('inview', function() {

	                if(captchaLoaded == false) {

	                	captchaLoaded = true;

										var script = document.createElement('script');
										script.onload = function () {
											// Get token
											getCaptchaToken();

											// Refresh token every 2 minutes
											setInterval(getCaptchaToken, 120000);
										};
										script.src = 'https://www.google.com/recaptcha/api.js?render=' + captcha_key;

										document.head.appendChild(script); //or something of the likes

	                }

								});

            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {

            		if($(window).width() > 767) {
            			$("video").html('<source src="' + $("source[data-src]").data("src") + '" type="video/mp4" />')
            		}

                // JavaScript to be fired on the home page, after the init JS
								$(".box-slider").one('inview', function() {
	                $('.box-slider').slick({
	                		lazyLoad: 'ondemand',
	                    slidesToShow: 1,
	                    slidesToScroll: 1,
	                    nextArrow: '<i class="fa fa-angle-right"></i>',
	                    prevArrow: '<i class="fa fa-angle-left"></i>',
	                    dots: true,
	                });
								});
            }
        },
        'tjanster': {
            init: function() {
                // JavaScript to be fired on the home page
                $('.tjanster-content').matchHeight();
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                // $('.group-detail .tjanster-content').matchHeight();
            }
        },
        'kontakta': {
            init: function() {
                // JavaScript to be fired on the home page
                // map
                $(".show-map").click(function() {
                    var lat = $(this).parents(".box-list-item-3").find('.lat').val();
                    var lng = $(this).parents(".box-list-item-3").find('.lng').val();
                    show_map(lat, lng, $(this).parents(".box-list-item-3"));
                    return false;
                });
                $('.map-detail .red').click(function() {
                    $('.group-map').removeClass('show');
                    $('.group-map').slideToggle();
                    $('.list-style-1').removeClass('close');
                    $('.list-style-1').slideToggle();
                });
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                // $('.group-detail .tjanster-content').matchHeight();
            }
        },
        'projekt': {
            init: function() {
                // JavaScript to be fired on the home page
                //$('.group-macth').matchHeight();
                $('.blog-macth').matchHeight();
                $(".filterByServiceArea").click(function() {
                    $(this).toggleClass("active");
                    filterProjects();
                    return false;
                });
                $(".filterByTag").click(function() {
                    $(this).toggleClass("active");
                    filterProjects();
                    return false;
                });
                $(".title-check").click(function() {
                    $(this).parents(".type-group").find('.detail-type').removeClass("active");
                    filterProjects();
                });
                $('.blog-group .blog.bolg-filter .button.border-black').click(function() {
                    $('.filter-projekt.mobile').slideToggle("active");
                    $('.overlay-black').toggleClass("active");
                });
                $('.filter-projekt .filter-title .close').click(function() {
                    console.log("test");
                    $('.filter-projekt.mobile').slideToggle("active");
                    $('.overlay-black').toggleClass("active");
                });
                function filterProjects() {
                    if ($(".filterByServiceArea.active").length == 0 && $(".filterByTag.active").length == 0) {
                        $(".title-check").removeClass("active");
                        $(".project").show();
                        return false;
                    }
                    $(".project").hide();
                    $(".project").each(function() {
                        var project = this;
                        var activeFilters = false;
                        $(".filterByServiceArea.active").each(function() {
                            if ($(project).hasClass("c" + $(this).data("service-area"))) {
                                $(project).show();
                            }
                            activeFilters = true;
                        });
                        $("#filterServiceAreas").find(".title-check").removeClass("active");
                        if (activeFilters) {
                            $("#filterServiceAreas").find(".title-check").removeClass("active").addClass("active");
                        }
                        activeFilters = false;
                        $(".filterByTag.active").each(function() {
                            if ($(project).hasClass("t" + $(this).data("tag"))) {
                                $(project).show();
                            }
                            activeFilters = true;
                        });
                        $("#filterTags").find(".title-check").removeClass("active");
                        if (activeFilters) {
                            $("#filterTags").find(".title-check").removeClass("active").addClass("active");
                        }
                    });
                    if (activeFilters) {
                    }
                }
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                // $('.group-detail .tjanster-content').matchHeight();
            }
        },
        'blogg': {
            init: function() {
                // JavaScript to be fired on the home page
                //$('.group-macth').matchHeight();
                $('.blog-macth').matchHeight();
                $('.title-type-mobile').click(function() {
                    $(this).toggleClass('active');
                    $('.filter-blog-mobile .group-filter').slideToggle('show');
                });
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                // $('.group-detail .tjanster-content').matchHeight();
            }
        },
    };
    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';
            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');
            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });
            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };
    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.